import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import './Menu.css'
import withPolyglot from '../common/withPolyglot'

const Menu = ({translate, navigation}) => {
  return <nav className='nav-bar uk-grid uk-child-width-expand@s uk-text-center'>
    {navigation.map((nav, i) => (
      <NavLink
        key={i}
        className='nav-link navigation'
        exact={nav.exact}
        activeClassName='active-nav'
        to={nav.path}>
        {translate(nav.name)}
      </NavLink>
    ))}
  </nav>
}

Menu.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      exact: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired
    })
  )
}

export default withPolyglot(Menu, 'menu')
